import { useState } from "react";
import { Box, Button, Typography } from "@mui/material";
import { Video as VideoIcon } from "lucide-react";
import VideoCallInitiator from "../components/video/VideoCallInitiator";
import { useNavigate } from "react-router-dom";
import FlexPage from "components/layout/FlexPage";

export default function Video() {
  const [videoCallOpen, setVideoCallOpen] = useState(false);
  const navigate = useNavigate();

  return (
    <FlexPage>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "16px" }}>
        <Typography variant="h1">Video Call</Typography>
        <Typography>
          Start a new video call session. You can share the call link with
          participants to join.
        </Typography>

        <Box>
          <Button
            variant="contained"
            startIcon={<VideoIcon />}
            onClick={() => setVideoCallOpen(true)}
          >
            Start Video Call
          </Button>
        </Box>

        {videoCallOpen && (
          <VideoCallInitiator
            onVideoRoomCreated={(roomUuid) => {
              setVideoCallOpen(false);
              navigate(`/video/${roomUuid}`);
            }}
            onCancel={() => setVideoCallOpen(false)}
          />
        )}
      </Box>
    </FlexPage>
  );
}
